import criminalFA from './fa/fa.json'

const CriminalMessages = {
  fa: { ...criminalFA },
}

export default CriminalMessages
